import { AppLocalizationKey, TechtimePayload } from '~/common/types/types';
import { teamCompositionPayload } from '~/components/main-page/data/data';
import { generateItems } from '~/helpers/helpers';

const TIMELINE_ITEMS_COUNT = 11;

const techtimePayload: TechtimePayload = {
  title: 'technology.qa.techtime.title',
  videoLecturesCount: 'technology.qa.techtime.videoLecturesCount',
  projectEnvironmentTitle: 'technology.qa.techtime.projectEnvironmentTitle',
  blocks: {
    lectures: {
      title: `technology.qa.techtime.group${0}.title` as AppLocalizationKey,
      period: `technology.qa.techtime.group${0}.period` as AppLocalizationKey,
      description:
        `technology.qa.techtime.group${0}.description` as AppLocalizationKey,
    },
    project: {
      title: `technology.qa.techtime.group${1}.title` as AppLocalizationKey,
      period: `technology.qa.techtime.group${1}.period` as AppLocalizationKey,
      description:
        `technology.qa.techtime.group${1}.description` as AppLocalizationKey,
    },
  },
  timeline: generateItems(TIMELINE_ITEMS_COUNT, (idx) => ({
    label:
      `technology.qa.techtime.timeline.lecture${idx}.label` as AppLocalizationKey,
    title:
      `technology.qa.techtime.timeline.lecture${idx}.title` as AppLocalizationKey,
    startDate:
      `technology.qa.techtime.timeline.lecture${idx}.startDate` as AppLocalizationKey,
  })),
  notice: 'technology.qa.techtime.notice' as AppLocalizationKey,
  teamCompositionPayload: teamCompositionPayload,
};

export { techtimePayload };
